import type { ColumnDef, Table } from "@tanstack/react-table";
import type { IUsuario } from "../../../modelos/Usuario/entidades/IUsuario";

interface ColumnasTablaUsuarioParams {
  tabla: Table<IUsuario>;
}

export const columnasTablaUsuario = ({
}: ColumnasTablaUsuarioParams): ColumnDef<IUsuario>[] => [
    { accessorKey: "NombreCompleto", header: "Nombre Completo" },
    { accessorKey: "Email", header: "Email" },
    { accessorKey: "Identificacion", header: "Identificación" },
    { accessorKey: "Telefono", header: "Teléfono" },
    { accessorKey: "PerfilUsuario.Nombre", header: "Perfil" },
    { accessorKey: "TipoTecnico.Nombre", header: "Tipo Técnico", cell: ({ getValue }) => getValue() || "--" },
    { accessorKey: "Pais.Nombre", header: "País" },
    { accessorKey: "Regional.Nombre", header: "Regional" },
    { accessorKey: "Ciudad.Nombre", header: "Ciudad" },
    { accessorKey: "Ruta", header: "Ruta" },
    { accessorKey: "Zona.Nombre", header: "Zona" },
    { accessorKey: "Activo", header: "Estado", cell: ({ getValue }) => getValue() ? "Activo" : "Inactivo" },
    { accessorKey: "CreadoUtc", header: "Fecha Creación", cell: ({ getValue }) => new Date(getValue() as string).toLocaleDateString() },
  ];






